module.exports = __webpack_public_path__ + "static/media/LTC.e33d5d68.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/crypto-icons/LTC.svg
// module id = 873
// module chunks = 0